import React from "react";
import { Link } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import "./SignupCommon.css";
import "./Signup6.css";

const DisqualifiedPage: React.FC = () => {
  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <div className="signup-content">
          <div className="error-container">
            <div className="error-box">
              <h1 className="error-condition">
                It appears that{" "}
                <span style={{ color: "#0C3972" }}>GLP-1 treatment</span> might
                not be the best fit for you at the moment.
              </h1>
            </div>
            <span className="error-content">
              Your refund will be processed as per our{" "}
              <a
                target="_blank"
                rel="noreferrer"
                className="suffix-support-email"
                href="https://claya.com/cancellation-and-refund-policy/"
              >
                refund policy
              </a>
              . If you have any questions, please contact us at{" "}
              <a href="mailto:support@claya.com" className="suffix-support-email">support@claya.com</a> or call us on{" "}
              <a href="tel:+19283704898" className="suffix-support-email">+1 (928) 370-4898</a>.
            </span>

            <Link to="https://claya.com/">
              <button className="next-btn">Explore claya membership</button>
            </Link>
          </div>

          <div style={{ paddingTop: "20px" }}>
            <span className="suffix-text-error">
              If you believe this is an error, please don’t hesitate to contact us at{" "}
              <a href="mailto:support@claya.com" className="suffix-support-email">
                support@claya.com
              </a>{" "}
              for assistance.
            </span>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default DisqualifiedPage;